<div [ngSwitch]="control.type" [class.hidden]="control.isHidden()">
  <app-text-control *ngSwitchDefault class="bg-gray" [control]="control" [form]="form"></app-text-control>

  <app-email-control *ngSwitchCase="email" class="bg-gray" [control]="control" [form]="form"></app-email-control>

  <app-password-control *ngSwitchCase="password" class="bg-gray" [control]="control" [form]="form"></app-password-control>

  <app-checkbox-control *ngSwitchCase="checkbox" class="bg-gray" [control]="control" [form]="form"></app-checkbox-control>

  <app-date-control *ngSwitchCase="date" class="bg-gray" [control]="control" [form]="form"></app-date-control>
  <app-age-control *ngSwitchCase="age" class="bg-gray" [control]="control" [form]="form"></app-age-control>

  <app-ahv-control *ngSwitchCase="ahv" class="bg-gray" [control]="control" [form]="form"></app-ahv-control>
  <app-phone-control *ngSwitchCase="phone" class="bg-gray" [control]="control" [form]="form"></app-phone-control>

  <app-select-control *ngSwitchCase="select" [control]="getControlAsSelect()" [form]="form"></app-select-control>

  <app-radio-control *ngSwitchCase="radio" class="control pt-2" [control]="getControlAsRadio()" [form]="form"></app-radio-control>
</div>
